

document.addEventListener("DOMContentLoaded", () => {
  const $ = (s) => document.querySelector(s);
  const mq = matchMedia("(max-width: 990px)");
  const rm = matchMedia("(prefers-reduced-motion: reduce)");

  const list = $(".pdp-highlights__list");
  if (!list) return;

  const viewport = list.closest(".pdp-highlights") || list.parentElement;

  list.dataset.orig ??= list.innerHTML;
  let onDown, onMove, onUp, on, off;

  function isVisible(el) {
    if (!el?.isConnected) return false;
    if (typeof el.checkVisibility === "function") {
      return el.checkVisibility({
        checkOpacity: true,
        checkVisibilityCSS: true,
      });
    }
    let n = el;
    while (n) {
      const s = getComputedStyle(n);
      if (s.display === "none" || s.visibility === "hidden") return false;
      n = n.parentElement;
    }
    return true;
  }

  function shouldRun() {
    return mq.matches && !rm.matches && isVisible(list);
  }

  const start = () => {
    if (!shouldRun() || list.dataset.enhanced) return;
    list.dataset.enhanced = "1";

    const orig = list.dataset.orig;
    const W0 = list.scrollWidth || 0;
    list.innerHTML = orig + orig;

    Object.assign(list.style, {
      display: "flex",
      willChange: "transform",
      transform: "translate3d(0,0,0)",
      transition: "transform 0s linear",
    });
    if (viewport) {
      viewport.style.overflow = "hidden";
      viewport.style.touchAction = "pan-y";
      viewport.style.overscrollBehavior = "contain";
    }

    let x = 0,
      v = 0,
      dragging = false,
      lastX = 0,
      W = W0 > 0 ? W0 : list.scrollWidth / 2;
    const base = 0.5,
      fric = 0.94;

    const wrap = () => {
      while (x >= W) x -= W;
      while (x < 0) x += W;
    };
    const recalc = () => {
      const nw = list.scrollWidth / 2;
      if (nw > 0 && Math.abs(nw - W) > 0.5) {
        x = ((x % nw) + nw) % nw;
        W = nw;
      }
    };

    on = () => (dragging = true);
    off = () => (dragging = false);
    ["mouseenter", "mouseleave"].forEach((ev, i) =>
      viewport?.addEventListener(ev, i % 2 ? off : on)
    );

    onDown = (e) => {
      dragging = true;
      v = 0;
      lastX = e.clientX;
      viewport?.setPointerCapture?.(e.pointerId);
    };
    onMove = (e) => {
      if (!dragging) return;
      const dx = e.clientX - lastX;
      lastX = e.clientX;
      if (Math.abs(dx) < 0.1) return;
      x -= dx;
      v = -dx;
      wrap();
      list.style.transform = `translate3d(-${x}px,0,0)`;
      e.preventDefault?.();
    };
    onUp = (e) => {
      dragging = false;
      viewport?.releasePointerCapture?.(e.pointerId);
    };

    viewport?.addEventListener("pointerdown", onDown, { passive: false });
    viewport?.addEventListener("pointermove", onMove, { passive: false });
    viewport?.addEventListener("pointerup", onUp);
    viewport?.addEventListener("pointercancel", onUp);

    (function loop() {
      if (!list.dataset.enhanced) return;
      if (!shouldRun()) {
        stop();
        return;
      }
      if (!dragging) {
        v = Math.abs(v) > base ? v * fric : base;
        x += v;
        wrap();
        list.style.transform = `translate3d(-${x}px,0,0)`;
      }
      list._raf = requestAnimationFrame(loop);
    })();

    list._ro = new ResizeObserver(recalc);
    list._ro.observe(list);
    if (viewport) list._ro.observe(viewport);
    list.querySelectorAll("img").forEach((img) =>
      img.complete || img.addEventListener("load", recalc, { once: true })
    );
  };

  const stop = () => {
    if (!list.dataset.enhanced) return;
    cancelAnimationFrame(list._raf || 0);
    list._raf = 0;
    list._ro && list._ro.disconnect();
    list._ro = null;

    ["mouseenter", "mouseleave"].forEach((ev, i) =>
      viewport?.removeEventListener(ev, i % 2 ? off : on)
    );
    viewport?.removeEventListener("pointerdown", onDown);
    viewport?.removeEventListener("pointermove", onMove);
    viewport?.removeEventListener("pointerup", onUp);
    viewport?.removeEventListener("pointercancel", onUp);

    list.innerHTML = list.dataset.orig;
    list.style.transform = "";
    list.style.display = "";
    list.style.willChange = "";
    list.style.transition = "";
    if (viewport) {
      viewport.style.overflow = "";
      viewport.style.touchAction = "";
      viewport.style.overscrollBehavior = "";
    }
    delete list.dataset.enhanced;
  };

  let syncTimer = 0;
  const sync = () => {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(() => {
      if (shouldRun()) {
        if (!list.dataset.enhanced) start();
      } else {
        stop();
      }
    }, 50);
  };

  sync();
  mq.addEventListener("change", sync);

  list._syncRo = new ResizeObserver(sync);
  list._syncRo.observe(list);
  if (viewport) list._syncRo.observe(viewport);

  list._syncIo = new IntersectionObserver(sync, { root: null, threshold: 0 });
  list._syncIo.observe(list);

  if (viewport) {
    list._syncMo = new MutationObserver(sync);
    list._syncMo.observe(viewport, {
      attributes: true,
      attributeFilter: ["style", "class"],
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const volumePricing = document.querySelector("volume-pricing");
  const formBlock = document.querySelector(".product-block--form");

  if (volumePricing && formBlock && formBlock.parentNode) {
    formBlock.parentNode.insertBefore(volumePricing, formBlock);
  }
});



